<template>
  <div class="min-h-screen bg-off-white pb-12 pt-6">
    <div class="pb-6">
      <img
        v-if="brokerLogo"
        class="mx-auto hidden h-11 w-auto md:block"
        :src="brokerLogo"
        alt="broker logo"
      />
    </div>
    <holding-tank-layout-wide :margin-under-logo="false">
      <!-- <img v-if="brokerLogo?.length > 0" class="h-11 w-auto mx-auto md:hidden my-6" :src="brokerLogo" alt="broker logo" /> -->
      <div
        v-if="
          latest_carrier_eld_provider?.connect_channel?.eld_type &&
          (latest_carrier_eld_provider?.connect_channel?.eld_type !==
            'eld_exempt' ||
            $store.state.carriers.carrierData
              ?.is_eld_exemption_submission_allowed == false)
        "
        class="w-full"
      >
        <div
          v-if="
            isEnabled_show_eld_coi_updates_in_onboarding &&
            showVerificationStatus &&
            hasFailingEldStatus == true
          "
          class="mx-auto my-8 w-full max-w-sm"
        >
          <div class="flex flex-col">
            <div class="flex items-center justify-between">
              <div class="text-3xl">Hmm...</div>
              <svg
                width="58"
                height="60"
                viewBox="0 0 38 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_204_57605)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.1556 24.0707C26.2789 24.0707 28.0002 22.3495 28.0002 20.2262C28.0002 19.4795 27.7873 18.7826 27.419 18.1927L24.2656 21.5105L23.9247 21.8691L23.5625 21.532L21.8258 19.9158L22.5071 19.1838L23.8816 20.4629L26.7784 17.4152C26.0915 16.774 25.1694 16.3816 24.1556 16.3816C22.0323 16.3816 20.311 18.1029 20.311 20.2262C20.311 22.3495 22.0323 24.0707 24.1556 24.0707Z"
                    fill="#F8C617"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23.778 9.02832C23.1673 9.38711 22.2931 9.6125 21.3211 9.6125C20.3491 9.6125 19.4923 9.39126 18.8824 9.03826C18.2726 9.39126 17.4058 9.6125 16.4438 9.6125C15.4818 9.6125 14.5976 9.38711 13.9869 9.02832L11.1481 15.2645C10.8755 15.8635 10.7306 16.5126 10.7225 17.1706C10.7144 17.8286 10.8434 18.4811 11.1011 19.0866C11.3588 19.692 11.7397 20.2372 12.2196 20.6875C12.6994 21.1378 13.2677 21.4834 13.8883 21.7021L18.8824 23.4605L20.1498 23.0142C19.7717 22.4684 19.5074 21.8483 19.3766 21.1909C19.1887 20.2461 19.2851 19.2668 19.6538 18.3768C20.0224 17.4869 20.6467 16.7262 21.4476 16.191C22.2486 15.6558 23.1903 15.3702 24.1536 15.3702C25.1586 15.3702 26.1316 15.6808 26.9442 16.2489C26.8729 15.9109 26.7647 15.5807 26.621 15.2645L23.778 9.02832Z"
                    fill="#F8C617"
                    fill-opacity="0.5"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.731 15.5829L21.3392 12.1378H19.5941L19.8985 14.4369H17.8706L18.175 12.1378H16.4299L13.8389 18.5707H17.3224L17.6276 16.2724H20.1416L20.2767 17.2928C20.6016 16.8656 20.9965 16.4927 21.4476 16.1914C21.8455 15.9255 22.2782 15.7212 22.731 15.5829Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.6616 8L14.3525 8.40589C14.8296 8.68619 15.581 8.89058 16.4436 8.89058C17.306 8.89058 18.0421 8.69041 18.5206 8.41347L18.8823 8.20413L19.2439 8.41347C19.7229 8.69072 20.4493 8.89058 21.3209 8.89058C22.1928 8.89058 22.9344 8.6865 23.412 8.40589L24.1025 8.00022L27.278 14.9658C27.5652 15.5975 27.7293 16.2776 27.762 16.9696C27.7087 16.9108 27.6538 16.8531 27.5974 16.7967C27.1475 16.3469 26.6187 15.9941 26.0435 15.7519C26.0186 15.6887 25.992 15.6261 25.9638 15.5641L25.9635 15.5634L23.4212 9.98668C22.7997 10.212 22.0765 10.3346 21.3209 10.3346C20.4146 10.3346 19.5692 10.1613 18.882 9.84883C18.1923 10.1615 17.3409 10.3346 16.4436 10.3346C15.6949 10.3346 14.9683 10.212 14.344 9.98625L11.805 15.5636C11.574 16.0714 11.4511 16.6218 11.4443 17.1796C11.4374 17.7374 11.5467 18.2905 11.7652 18.8039C11.9837 19.3172 12.3066 19.7794 12.7134 20.1611C13.1202 20.5428 13.6019 20.8357 14.1279 21.0212L18.8823 22.6951L19.7777 22.3798C19.9974 22.8292 20.286 23.2442 20.6351 23.6088L18.8823 24.226L13.6484 22.3832C12.9333 22.1311 12.2782 21.7329 11.7253 21.2141C11.1724 20.6952 10.7336 20.067 10.4366 19.3694C10.1396 18.6718 9.9911 17.92 10.0004 17.1618C10.0097 16.4037 10.1767 15.6557 10.4907 14.9656L13.6616 8Z"
                    fill="#F8C617"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_204_57605"
                    x="0"
                    y="3"
                    width="38"
                    height="36.226"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_204_57605"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_204_57605"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <div class="mt-2 text-left text-body-color">
              <div v-if="eldStatus == 'no_vins_on_coi'">
                It looks like the vehicles on your ELD account don't match the
                vehicles on your certificate of insurance (COI). Please instruct
                your insurance agency to email your updated COI and VIN schedule
                to
                <a
                  href="mailto:insurance@certs.highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >insurance@certs.highway.com</a
                >, or contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
              <div v-else-if="eldStatus == 'bipd_not_on_file'">
                It looks like we have not yet processed your certificate of
                insurance (COI). Please ensure that your insurance agency has
                emailed your updated COI and VIN schedule to
                <a
                  href="mailto:insurance@certs.highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >insurance@certs.highway.com</a
                >, or contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
              <div
                v-else-if="
                  eldStatus == 'eld_vins_not_on_coi' ||
                  eldStatus == 'some_eld_vin_matches_on_coi'
                "
              >
                It looks like
                {{
                  eldStatus == 'some_eld_vin_matches_on_coi' ? 'some of ' : ''
                }}the vehicles on your ELD account don't match the vehicles on
                your certificate of insurance (COI). Please instruct your
                insurance agency to email your updated COI and VIN schedule to
                <a
                  href="mailto:insurance@certs.highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >insurance@certs.highway.com</a
                >, or contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
              <div v-if="eldStatus == 'missing_vins_on_eld'">
                It looks like the vehicles on your ELD account do not have a
                vehicle identification number (VIN). Please update each of the
                vehicles in your ELD account with this information, or contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
              <div v-if="eldStatus == 'no_active_vehicles_found_on_eld'">
                It looks like we were not able to detect recent movements for
                any of the vehicles on your ELD account. Please contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
              <div v-else-if="eldStatus == 'no_eld_vin_matches_on_coi'">
                It looks like none of the vehicles on your ELD account match the
                vehicles on your certificate of insurance (COI). Please instruct
                your insurance agency to email your updated COI and VIN schedule
                to
                <a
                  href="mailto:insurance@certs.highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >insurance@certs.highway.com</a
                >, or contact
                <a
                  href="mailto:eldservice@highway.com"
                  class="text-yellow-500 underline hover:text-yellow-600"
                  >eldservice@highway.com</a
                >
                for help.
              </div>
            </div>
            <div class="mb-2 mt-6 w-full">
              <button-main
                v-if="hasEldConnectedAndActive"
                variant="primary"
                @click="closeEld"
              >
                Continue
              </button-main>
              <button-main
                v-else
                variant="primary"
                @click="handleBack"
              >
                Try Again
              </button-main>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.is_certified_eld !==
              true &&
            latest_carrier_eld_provider?.connect_channel
              ?.is_skip_unqualified_eld_screen !== true &&
            (!latest_carrier_eld_provider?.has_sent_certification_invite ||
              (!should_show_certification_site_notice_expiration &&
                !latest_carrier_eld_provider?.connect_channel
                  ?.is_manual_eld_signup_allowed &&
                latest_carrier_eld_provider?.has_sent_certification_invite))
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-light-gray text-xl"
              :class="{
                'border-b px-4 py-4':
                  should_show_certification_site_notice_expiration ||
                  latest_carrier_eld_provider?.connect_channel
                    ?.is_manual_eld_signup_allowed,
              }"
            >
              <span
                v-if="
                  should_show_certification_site_notice_expiration ||
                  latest_carrier_eld_provider?.connect_channel
                    ?.is_manual_eld_signup_allowed
                "
              >
                {{ latest_carrier_eld_provider?.connect_channel?.name }}
              </span>
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleBack"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="closeModal"
                  >
                    Close
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div
                v-if="siteNoticeText"
                class="w-full"
              >
                <site-notice>
                  <span class="pr-1 font-bold">ATTENTION:</span
                  >{{ siteNoticeText }}
                </site-notice>
              </div>
              <div
                class="w-full text-left text-body-color"
                :class="{
                  'mt-3':
                    should_show_certification_site_notice_expiration ||
                    latest_carrier_eld_provider?.connect_channel
                      ?.is_manual_eld_signup_allowed,
                }"
              >
                <!-- <span class="text-start text-dark-gray text-lg leading-0"
                  >Unqualified ELD Provider</span
                > -->
                <div
                  v-if="
                    should_show_certification_site_notice_expiration ||
                    latest_carrier_eld_provider?.connect_channel
                      ?.is_manual_eld_signup_allowed
                  "
                  class="pb-1 text-xs text-body-color"
                >
                  Contact your current ELD provider in order to continue today.
                </div>
                <div v-else>
                  <p class="mb-3 text-sm text-body-color">
                    {{ latest_carrier_eld_provider?.connect_channel?.name }} is
                    not certified by Highway.
                  </p>
                  <p class="mb-2 text-xs text-body-color">
                    More than 99% of all motor carriers in the United States use
                    one of the 250+ ELD providers that Highway integrates with
                    in real-time. Please have your ELD provider reach out to
                    Highway at
                    <a
                      href="mailto:eldintegrations@highway.com"
                      class="text-yellow-500 underline hover:text-yellow-600"
                      >eldintegrations@highway.com</a
                    >
                    to complete their certification with Highway.
                  </p>
                </div>
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3 pb-1">
                  <div class="w-full">
                    <vue-collapsible-panel
                      class="rounded-md border border-light-gray shadow-black"
                      :expanded="
                        !(
                          should_show_certification_site_notice_expiration ||
                          latest_carrier_eld_provider?.connect_channel
                            ?.is_manual_eld_signup_allowed
                        )
                      "
                    >
                      <template #title>
                        <span
                          class="inline-block w-full py-4 text-center text-dark-gray"
                          >View Certified ELD Providers</span
                        >
                      </template>
                      <template #content>
                        <div
                          v-if="certified_eld_providers?.length > 0"
                          class="flex w-full flex-col gap-3 p-2 text-left"
                        >
                          <div
                            v-for="(eld, index) in certified_eld_providers"
                            :key="index"
                            class="group grid w-full grid-cols-4 rounded-md border border-light-gray"
                          >
                            <div
                              class="col-span-1 flex flex-1 items-center justify-center p-2 px-3"
                              :class="[
                                eld?.logo?.url
                                  ? 'border-r border-light-gray'
                                  : 'bg-lighter-gray',
                              ]"
                            >
                              <div class="w-48">
                                <img
                                  v-if="eld?.logo?.url"
                                  class="w-auto"
                                  :src="eld?.logo?.url"
                                  :alt="eld?.name"
                                />
                                <div
                                  v-else
                                  class="flex h-full w-full items-center justify-center text-center text-xs text-body-color"
                                >
                                  {{ eld?.name }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-span-3 flex flex-1 flex-grow flex-col gap-2 rounded-r-md bg-white p-2 px-3 text-xs group-hover:bg-off-white"
                            >
                              <div class="flex items-center justify-between">
                                <div class="font-bold text-dark-gray">
                                  {{ eld?.name }}
                                </div>
                                <div
                                  v-if="eld?.marketing_url"
                                  class="col-span-1 text-body-color"
                                >
                                  <a
                                    :href="`${eld?.marketing_url}`"
                                    target="_blank"
                                    class="flex cursor-pointer items-center gap-1 hover:text-yellow-600"
                                  >
                                    <svg
                                      class="relative h-5 w-5"
                                      style="right: 2px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
                                        stroke="currentColor"
                                        stroke-width="1.75"
                                      />
                                      <path
                                        d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
                                        stroke="currentColor"
                                        stroke-width="1"
                                      />
                                    </svg>
                                    <div>Visit Website</div>
                                  </a>
                                </div>
                              </div>
                              <div
                                class="grid grid-cols-2 gap-y-1.5 text-body-color"
                              >
                                <div
                                  v-if="eld?.marketing_phone"
                                  class="col-span-2"
                                >
                                  <a
                                    :href="`tel:${eld?.marketing_phone}`"
                                    class="flex cursor-pointer items-center gap-1.5 hover:text-yellow-600"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      class="relative top-px"
                                    >
                                      <g clip-path="url(#clip0_23_4290)">
                                        <path
                                          d="M14.6666 11.3947V13.3947C14.6673 13.5804 14.6293 13.7642 14.5549 13.9343C14.4805 14.1044 14.3714 14.2571 14.2346 14.3826C14.0978 14.5082 13.9363 14.6037 13.7604 14.6632C13.5845 14.7227 13.3982 14.7448 13.2132 14.7281C11.1618 14.5052 9.19125 13.8042 7.45991 12.6814C5.84913 11.6578 4.48347 10.2922 3.45991 8.6814C2.33323 6.9422 1.63208 4.96206 1.41325 2.9014C1.39659 2.71704 1.4185 2.53124 1.47758 2.35581C1.53667 2.18039 1.63163 2.01919 1.75643 1.88248C1.88122 1.74576 2.03312 1.63654 2.20244 1.56174C2.37177 1.48695 2.55481 1.44824 2.73991 1.44806H4.73991C5.06345 1.44488 5.37711 1.55945 5.62242 1.77042C5.86774 1.98139 6.02797 2.27436 6.07325 2.59473C6.15766 3.23477 6.31421 3.86321 6.53992 4.46806C6.62961 4.70668 6.64902 4.96601 6.59585 5.21532C6.54268 5.46463 6.41916 5.69347 6.23991 5.87473L5.39325 6.7214C6.34229 8.39043 7.72422 9.77236 9.39325 10.7214L10.2399 9.87473C10.4212 9.69549 10.65 9.57196 10.8993 9.51879C11.1486 9.46562 11.408 9.48503 11.6466 9.57473C12.2514 9.80043 12.8799 9.95698 13.5199 10.0414C13.8438 10.0871 14.1395 10.2502 14.3509 10.4997C14.5624 10.7493 14.6747 11.0678 14.6666 11.3947Z"
                                          stroke="currentColor"
                                          stroke-width="1.33333"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_23_4290">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            transform="translate(0 0.114746)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <div>
                                      {{ phoneFormat(eld?.marketing_phone) }}
                                    </div>
                                  </a>
                                </div>
                                <div
                                  v-if="eld?.marketing_email"
                                  class="col-span-2"
                                >
                                  <a
                                    :href="`mailto:${eld?.marketing_email}`"
                                    class="flex cursor-pointer items-center gap-2 hover:text-yellow-600"
                                  >
                                    <svg
                                      class="flex-shrink-0"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      style="margin-top: 1.1px"
                                    >
                                      <path
                                        d="M2.66671 2.78149H13.3334C14.0667 2.78149 14.6667 3.38149 14.6667 4.11483V12.1148C14.6667 12.8482 14.0667 13.4482 13.3334 13.4482H2.66671C1.93337 13.4482 1.33337 12.8482 1.33337 12.1148V4.11483C1.33337 3.38149 1.93337 2.78149 2.66671 2.78149Z"
                                        stroke="currentColor"
                                        stroke-width="1.33333"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M14.6667 4.11475L8.00004 8.78141L1.33337 4.11475"
                                        stroke="currentColor"
                                        stroke-width="1.33333"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    <div class="truncate">
                                      {{ eld?.marketing_email }}
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="eld?.marketing_discount_text"
                              class="col-span-4 flex items-center justify-center rounded-b-md bg-dark-gray py-0.5 text-xs font-bold text-yellow-500"
                            >
                              <span>{{ eld?.marketing_discount_text }}</span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-collapsible-panel>
                  </div>
                  <div class="w-full">
                    <vue-collapsible-panel
                      class="rounded-md border border-light-gray shadow-black"
                      :expanded="
                        should_show_certification_site_notice_expiration ||
                        latest_carrier_eld_provider?.connect_channel
                          ?.is_manual_eld_signup_allowed
                      "
                    >
                      <template #title>
                        <span
                          class="inline-block w-full py-4 text-center text-dark-gray"
                          >Contact My ELD Provider</span
                        >
                      </template>
                      <template #content>
                        <div
                          class="flex grid w-full grid-cols-4 gap-3 p-2 py-3 text-left text-sm"
                        >
                          <div class="col-span-1">To:</div>
                          <div class="col-span-3">
                            {{
                              latest_carrier_eld_provider?.connect_channel
                                ?.marketing_email
                            }}
                          </div>
                          <div class="col-span-1">Subject:</div>
                          <div class="col-span-3">
                            Please get certified with Highway
                          </div>
                          <!-- <div class="col-span-4">Message:</div> -->
                          <div class="col-span-4">
                            <textarea
                              v-model="certification_email_message"
                              class="w-full rounded-md border-none bg-off-white text-sm"
                              name="certification_email_message"
                              cols="30"
                              rows="12"
                            />
                          </div>
                        </div>
                        <div class="w-full p-2 pt-0">
                          <button-main
                            variant="primary"
                            @click="handleSendCertificationEmail"
                          >
                            <span
                              v-if="
                                should_show_certification_site_notice_expiration ||
                                latest_carrier_eld_provider?.connect_channel
                                  ?.is_manual_eld_signup_allowed
                              "
                              >Send Email & Continue</span
                            >
                            <span v-else>Send Email</span>
                          </button-main>
                        </div>
                      </template>
                    </vue-collapsible-panel>
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <!-- <button-main
                      @click="handleSubmitVerify"
                      :disabled="!canSubmit"
                      :isLoading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :customBg="buttonBg"
                      >{{ isUpdate ? "Update" : "Continue" }}
                    </button-main> -->
                    <div class="w-full">
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        <span class="text-xs sm:text-sm"
                          >Choose a different ELD provider</span
                        >
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-center mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span> -->
          <!-- <div class="w-full">
              <radio-button :item="checkboxText" :active="isChecked == true" :handleSelect="handleCheckbox"
                name="checkbox-confirm"></radio-button>
            </div> -->
          <!-- <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.is_oauth == true &&
            !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <p class="h4-style mb-3">
            Authenticate through
            {{ latest_carrier_eld_provider?.connect_channel?.name }}
          </p>
          <div
            v-if="currentIntegration"
            class="flex flex-col gap-4"
          >
            <integration-cta
              :key="currentIntegration?.name"
              :item="currentIntegration"
              :packet-id="packetId"
              @modal-to-show="handleModalToShow"
            />
          </div>
          <p class="mt-4 text-body-color">
            {{
              getAuthenticationMessage(
                latest_carrier_eld_provider?.connect_channel?.is_oauth
              )
            }}
          </p>
          <div class="mt-6 w-full">
            <button-main
              variant="secondary"
              @click="handleBack"
            >
              Back
            </button-main>
          </div>
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            [
              'api_key',
              'api_id_and_api_key',
              'company_id_for_hos_connect',
            ].includes(
              latest_carrier_eld_provider?.connect_channel?.retrieval_type
            ) && !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleUpdateCredentials"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="primary"
                    @click="closeEld"
                  >
                    Continue
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >{{ isUpdate ? 'Update' : 'Enter' }} your credentials</span
                >
                <div class="text-xs text-body-color">
                  Your credentials will be used to securely verify your
                  equipment and recent activity.
                </div>
                <div
                  v-if="apiInstructionsUrl?.length > 0"
                  class="w-full text-right"
                  style="line-height: 1"
                >
                  <div class="inline-block">
                    <div
                      class="flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap text-xs text-yellow-500 hover:text-yellow-600"
                      @click="openApiInstructionsUrl()"
                    >
                      <span>How do I find my API key?</span>
                      <svg
                        class="h-4 w-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                        <path
                          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <!-- <div class="w-full mb-2">
                    <span class="text-start text-dark-gray text-sm mt-3">Paste your {{ latest_carrier_eld_provider?.connect_channel?.name }} API key here:</span>
                  </div> -->
                  <div
                    v-if="
                      latest_carrier_eld_provider?.connect_channel
                        ?.retrieval_type == 'company_id_for_hos_connect'
                    "
                    class="flex w-full items-center justify-start"
                  >
                    <div class="relative w-full">
                      <input
                        v-model="eld_verifier_company_id"
                        type="text"
                        class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                        :placeholder="getCompanyIdDescription"
                      />
                    </div>
                  </div>
                  <template v-else>
                    <div class="flex w-full items-center justify-start">
                      <div class="relative w-full">
                        <input
                          v-model="eld_verifier"
                          :type="eld_verifier_input_type"
                          class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                          style="padding-right: 40px"
                          :placeholder="getApiKeyDescription"
                        />
                        <div
                          v-if="eld_verifier?.length > 0"
                          class="absolute right-3 top-0 flex h-full items-center justify-center"
                        >
                          <div
                            class="cursor-pointer text-gray-over-dark"
                            @click="verifier_visible = !verifier_visible"
                          >
                            <svg
                              v-if="verifier_visible == false"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="h-5 w-5"
                            >
                              <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                              <path
                                fill-rule="evenodd"
                                d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                                clip-rule="evenodd"
                              />
                            </svg>
                            <svg
                              v-else
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="h-5 w-5"
                            >
                              <path
                                d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                              />
                              <path
                                d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                              />
                              <path
                                d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        latest_carrier_eld_provider?.connect_channel
                          ?.retrieval_type == 'api_id_and_api_key'
                      "
                      class="flex w-full items-center justify-start"
                    >
                      <div class="relative w-full">
                        <input
                          v-model="eld_verifier_id"
                          type="text"
                          class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                          :placeholder="getApiIdDescription"
                        />
                      </div>
                    </div>
                  </template>
                  <!-- <div class="w-full relative">
                    <input type="text" v-model="user_email"
                      class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray"
                      :class="[ !showErrors ? '' : !isValidEmail ? 'bg-red-100 focus:bg-red-100 border-red-500 text-red-500 hover:border-red-500 focus:text-red-500 focus:border-red-500 failed-validation' : '' ]"
                      placeholder="Username"/>
                      <span v-if="showErrors && !isValidEmail" class="text-red-500 text-2xs pt-0.5 pl-1 text-left block">Username must be a valid email address</span>
                  </div>
                  <div class="w-full relative">
                    <input :type="code_input_type" v-model="user_code"
                      class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray" placeholder="Password"
                      style="padding-right: 40px;" />
                    <div v-if="user_code?.length > 0" class="absolute right-3 top-0 h-full flex items-center justify-center">
                      <div @click="code_visible = !code_visible" class="text-gray-over-dark cursor-pointer">
                        <svg v-if="code_visible == false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                          <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clip-rule="evenodd" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                          <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                          <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                          <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                        </svg>
                      </div>
                    </div>
                  </div> -->
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="
                        eld_verifier?.length < 1 &&
                        eld_verifier_company_id?.length < 1
                      "
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitApi"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div class="mt-3 w-full">
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        Choose a different ELD provider
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <p class="h4-style mb-6 -mt-3">Authenticate through {{ latest_carrier_eld_provider?.connect_channel?.name }}</p>
          <p class="mt-4 mb-1 text-dark-blue text-base">Step 1</p>
          <div class="flex flex-col gap-4">
            <div class="w-full mb-2">
              <span class="text-start text-dark-gray text-sm mt-3">Generate an API key for your account</span>
            </div>
            <eld-cta-api :key="`latest_carrier_eld_provider_${latest_carrier_eld_provider?.id}`"
              :item="latest_carrier_eld_provider?.connect_channel" :packetId="packetId"
              :latestCarrierEldProvider="latest_carrier_eld_provider" @modal-to-show="handleModalToShow"
              :apiInstructionsUrl="latest_carrier_eld_provider?.connect_channel?.api_instructions_url"
              :text="`Click below to view instructions for generating an API key for your ${latest_carrier_eld_provider?.connect_channel?.name} account`">
            </eld-cta-api>
          </div>

          <p class="mt-6 mb-1 dark-blue text-base">Step 2</p>
          <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <div class="w-full mb-2">
              <span class="text-start text-dark-gray text-sm mt-3">Paste your {{ latest_carrier_eld_provider?.connect_channel?.name }} API key here:</span>
            </div>
            <div class="flex justify-start items-center w-full">
              <div class="w-full relative">
                <input :type="eld_verifier_input_type" v-model="eld_verifier"
                  class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray"
                  style="padding-right: 40px;" />
                <div v-if="eld_verifier?.length > 0" class="absolute right-3 top-0 h-full flex items-center justify-center">
                  <div @click="verifier_visible = !verifier_visible" class="text-gray-over-dark cursor-pointer">
                    <svg v-if="verifier_visible == false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                      <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                      <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clip-rule="evenodd" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                      <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                      <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                      <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="mt-6 mb-1 dark-blue text-base">Step 3 </p>
          <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-start mt-3 mb-4">Submit and hang tight while we verify your account</span>
            <div class="mt-3 w-full">
              <button-main @click="handleSubmitApi" :disabled="eld_verifier?.length < 1" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.retrieval_type ===
            'carrier_consent'
          "
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <section
                v-if="currentEldIntegration"
                class="my-10"
              >
                <p class="text-left text-body-color">
                  Thank you for providing consent to Highway to connect your ELD
                  with our platform. If you have completed the SmartSheet,
                  Highway will be in touch with you in the next 72 hours to
                  update you on the status of your ELD connection. If you did
                  not complete the SmartSheet after you originally provided us
                  with consent,
                  <a
                    target="_blank"
                    :href="
                      latest_carrier_eld_provider?.connect_channel?.redirect_url
                    "
                    class="cursor-pointer text-yellow-500 underline hover:opacity-80"
                    >please click this link to do so</a
                  >. Please do not fill out the SmartSheet again if you have
                  already completed it. Questions about the status of your
                  integration? Please contact Highway at
                  <a
                    class="text-yellow-500"
                    href="mailto:eldservice@highway.com"
                    >eldservice@highway.com</a
                  >.
                </p>
              </section>
              <template v-else>
                <div class="mt-3 w-full text-left text-body-color">
                  <span class="leading-0 text-start text-lg text-dark-gray"
                    >Add Highway Via
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  </span>
                  <div class="text-xs text-body-color">
                    Click the box below to provide consent to Highway to connect
                    your PeopleNet to Highway.
                  </div>
                </div>
                <div class="mt-3 flex w-full items-center justify-center">
                  <div class="flex w-full flex-col gap-3">
                    <div class="mb-3 w-full">
                      <radio-button
                        :item="
                          latest_carrier_eld_provider?.connect_channel
                            ?.consent_message
                        "
                        :active="isMarketplaceChecked == true"
                        :handle-select="handleMarketplaceCheckbox"
                        name="checkbox-confirm"
                        style="padding-top: 0.5rem; padding-bottom: 0.5rem"
                      />
                    </div>
                    <button-main
                      class="mb-4"
                      :disabled="!isMarketplaceChecked"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="
                        redirectTo(
                          latest_carrier_eld_provider?.connect_channel
                            ?.redirect_url
                        )
                      "
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.retrieval_type ===
            'custom_message'
          "
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color"></div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="mb-3 w-full">
                    <p
                      class="text-left"
                      v-html="
                        latest_carrier_eld_provider?.connect_channel
                          ?.consent_message
                      "
                    ></p>
                  </div>
                  <button-main
                    class="mb-4"
                    variant="secondary"
                    :custom-bg="buttonBg"
                    @click="handleBack"
                  >
                    Back
                  </button-main>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
              'marketplace_request' && !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleBack"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="closeModal"
                  >
                    Close
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >Approve Request in
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  portal</span
                >
                <div class="text-xs text-body-color">
                  Please click the button below to log into your account and
                  approve the request.
                </div>
                <!-- <div
                  v-if="apiInstructionsUrl?.length > 0"
                  class="w-full text-right"
                  style="line-height: 1"
                >
                  <div class="inline-block">
                    <div
                      @click="openApiInstructionsUrl()"
                      class="flex gap-1 text-yellow-500 justify-center cursor-pointer items-center whitespace-nowrap text-xs hover:text-yellow-600"
                    >
                      <span>How do I authenticate?</span>
                      <svg
                        class="w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                        <path
                          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="w-full">
                    <button-main
                      class="brand-btn w-full text-sm font-medium uppercase text-white"
                      :style="[
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code
                          ? 'background-color:#' +
                            latest_carrier_eld_provider?.connect_channel?.brand_color_hex_code?.replaceAll(
                              '#',
                              ''
                            ) +
                            ';color:#FFFFFF;'
                          : '',
                      ]"
                      variant="custom"
                      @click="openManualLoginUrl()"
                    >
                      <!-- <span
                        v-if="hasActiveSubscription(item.name)"
                        class="flex gap-2 items-center justify-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="currentColor"
                          class="w-4 h-4 relative"
                          style="top: -0.5px"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.5 12.75l6 6 9-13.5"
                          />
                        </svg>
                        <span>Connected</span>
                      </span> -->
                      <span
                        >Approve via
                        {{ latest_carrier_eld_provider?.connect_channel?.name }}
                        Portal</span
                      >
                    </button-main>
                  </div>
                  <div class="mt-3 w-full">
                    <div class="text-left text-xs text-body-color">
                      Once you have completed this process, please click the
                      checkbox below to confirm and continue.
                    </div>
                  </div>
                  <div class="mb-3 w-full">
                    <radio-button
                      :item="
                        marketplaceRequestCheckboxText(
                          latest_carrier_eld_provider?.connect_channel?.name
                        )
                      "
                      :active="isMarketplaceChecked == true"
                      :handle-select="handleMarketplaceCheckbox"
                      name="checkbox-confirm"
                      style="padding-top: 0.5rem; padding-bottom: 0.5rem"
                    />
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="!isMarketplaceChecked"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitMarketplace"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div
                      v-if="isUpdate"
                      class="mt-3 w-full"
                    >
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        <span class="text-xs sm:text-sm"
                          >Choose a different ELD provider</span
                        >
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-center mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span> -->
          <!-- <div class="w-full">
              <radio-button :item="checkboxText" :active="isChecked == true" :handleSelect="handleCheckbox"
                name="checkbox-confirm"></radio-button>
            </div> -->
          <!-- <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
              'marketplace' && !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleBack"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="closeModal"
                  >
                    Close
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >Add Highway via
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  portal</span
                >
                <div class="text-xs text-body-color">
                  Please click the button below to authenticate your account.
                </div>
                <!-- <div
                  v-if="apiInstructionsUrl?.length > 0"
                  class="w-full text-right"
                  style="line-height: 1"
                >
                  <div class="inline-block">
                    <div
                      @click="openApiInstructionsUrl()"
                      class="flex gap-1 text-yellow-500 justify-center cursor-pointer items-center whitespace-nowrap text-xs hover:text-yellow-600"
                    >
                      <span>How do I authenticate?</span>
                      <svg
                        class="w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                        <path
                          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="w-full">
                    <button-main
                      class="brand-btn w-full text-sm font-medium uppercase text-white"
                      :style="[
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code
                          ? 'background-color:#' +
                            latest_carrier_eld_provider?.connect_channel?.brand_color_hex_code?.replaceAll(
                              '#',
                              ''
                            ) +
                            ';color:#FFFFFF;'
                          : '',
                      ]"
                      variant="custom"
                      @click="openManualLoginUrl()"
                    >
                      <!-- <span
                        v-if="hasActiveSubscription(item.name)"
                        class="flex gap-2 items-center justify-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="currentColor"
                          class="w-4 h-4 relative"
                          style="top: -0.5px"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.5 12.75l6 6 9-13.5"
                          />
                        </svg>
                        <span>Connected</span>
                      </span> -->
                      <span
                        >Add Highway via
                        {{ latest_carrier_eld_provider?.connect_channel?.name }}
                        Portal</span
                      >
                    </button-main>
                  </div>
                  <div class="mt-3 w-full">
                    <div class="text-left text-xs text-body-color">
                      Once you have completed this process, please click the
                      checkbox below to confirm and continue.
                    </div>
                  </div>
                  <div class="mb-3 w-full">
                    <radio-button
                      :item="
                        marketplaceCheckboxText(
                          latest_carrier_eld_provider?.connect_channel?.name
                        )
                      "
                      :active="isMarketplaceChecked == true"
                      :handle-select="handleMarketplaceCheckbox"
                      name="checkbox-confirm"
                      style="padding-top: 0.5rem; padding-bottom: 0.5rem"
                    />
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="!isMarketplaceChecked"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitMarketplace"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div
                      v-if="isUpdate"
                      class="mt-3 w-full"
                    >
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        <span class="text-xs sm:text-sm"
                          >Choose a different ELD provider</span
                        >
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-center mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span> -->
          <!-- <div class="w-full">
              <radio-button :item="checkboxText" :active="isChecked == true" :handleSelect="handleCheckbox"
                name="checkbox-confirm"></radio-button>
            </div> -->
          <!-- <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            [
              'username_pass_and_c_g_root',
              'username_pass_and_company_id',
            ].includes(
              latest_carrier_eld_provider?.connect_channel?.retrieval_type
            ) && !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleBack"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="closeModal"
                  >
                    Close
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >{{ isUpdate ? 'Update' : 'Enter' }} your credentials</span
                >
                <div
                  v-if="temporarilyCollectUsernameAndPassword"
                  class="text-xs text-body-color"
                >
                  We are currently in the process of integrating with
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}. In
                  the meantime, please provide us with the credentials for your
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  account so that we can securely verify your equipment and
                  recent activity.
                </div>
                <div
                  v-else-if="!isUpdate"
                  class="text-xs text-body-color"
                >
                  Your credentials will be used to securely verify your
                  equipment and recent activity.
                </div>
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="relative w-full">
                    <input
                      v-model="eld_verifier_company_id"
                      type="text"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :placeholder="getCgRootDescription"
                    />
                  </div>
                  <div class="relative w-full">
                    <input
                      v-model="user_email"
                      type="text"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :class="[
                        !showErrors
                          ? ''
                          : !isValidEmail
                            ? 'failed-validation border-red-500 bg-red-100 text-red-500 hover:border-red-500 focus:border-red-500 focus:bg-red-100 focus:text-red-500'
                            : '',
                      ]"
                      :placeholder="getUsernameDescription"
                    />
                    <span
                      v-if="showErrors && !isValidEmail"
                      class="block pl-1 pt-0.5 text-left text-2xs text-red-500"
                      >Username must be a valid email address</span
                    >
                  </div>
                  <div class="relative w-full">
                    <input
                      v-model="user_code"
                      :type="code_input_type"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :placeholder="getPasswordDescription"
                      style="padding-right: 40px"
                    />
                    <div
                      v-if="user_code?.length > 0"
                      class="absolute right-3 top-0 flex h-full items-center justify-center"
                    >
                      <div
                        class="cursor-pointer text-gray-over-dark"
                        @click="code_visible = !code_visible"
                      >
                        <svg
                          v-if="code_visible == false"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                          <path
                            fill-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path
                            d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                          />
                          <path
                            d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                          />
                          <path
                            d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="!canSubmit"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitUserPassCGRoot"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div
                      v-if="isUpdate"
                      class="mt-3 w-full"
                    >
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        <span class="text-xs sm:text-sm"
                          >Choose a different ELD provider</span
                        >
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-center mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span> -->
          <!-- <div class="w-full">
              <radio-button :item="checkboxText" :active="isChecked == true" :handleSelect="handleCheckbox"
                name="checkbox-confirm"></radio-button>
            </div> -->
          <!-- <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
              'username_pass_and_api_key_for_api' &&
            !temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleBack"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="closeModal"
                  >
                    Close
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >{{ isUpdate ? 'Update' : 'Enter' }} your credentials</span
                >
                <div
                  v-if="temporarilyCollectUsernameAndPassword"
                  class="text-xs text-body-color"
                >
                  We are currently in the process of integrating with
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}. In
                  the meantime, please provide us with the credentials for your
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  account so that we can securely verify your equipment and
                  recent activity.
                </div>
                <div
                  v-else-if="!isUpdate"
                  class="text-xs text-body-color"
                >
                  Your credentials will be used to securely verify your
                  equipment and recent activity.
                </div>
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="relative w-full">
                    <input
                      v-model="eld_verifier"
                      :type="eld_verifier_input_type"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      style="padding-right: 40px"
                      :placeholder="getApiKeyDescription"
                    />
                    <div
                      v-if="eld_verifier?.length > 0"
                      class="absolute right-3 top-0 flex h-full items-center justify-center"
                    >
                      <div
                        class="cursor-pointer text-gray-over-dark"
                        @click="verifier_visible = !verifier_visible"
                      >
                        <svg
                          v-if="verifier_visible == false"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                          <path
                            fill-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path
                            d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                          />
                          <path
                            d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                          />
                          <path
                            d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="relative w-full">
                    <input
                      v-model="user_email"
                      type="text"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :class="[
                        !showErrors
                          ? ''
                          : !isValidEmail
                            ? 'failed-validation border-red-500 bg-red-100 text-red-500 hover:border-red-500 focus:border-red-500 focus:bg-red-100 focus:text-red-500'
                            : '',
                      ]"
                      :placeholder="getUsernameDescription"
                    />
                    <span
                      v-if="showErrors && !isValidEmail"
                      class="block pl-1 pt-0.5 text-left text-2xs text-red-500"
                      >Username must be a valid email address</span
                    >
                  </div>
                  <div class="relative w-full">
                    <input
                      v-model="user_code"
                      :type="code_input_type"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :placeholder="getPasswordDescription"
                      style="padding-right: 40px"
                    />
                    <div
                      v-if="user_code?.length > 0"
                      class="absolute right-3 top-0 flex h-full items-center justify-center"
                    >
                      <div
                        class="cursor-pointer text-gray-over-dark"
                        @click="code_visible = !code_visible"
                      >
                        <svg
                          v-if="code_visible == false"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                          <path
                            fill-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path
                            d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                          />
                          <path
                            d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                          />
                          <path
                            d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="!canSubmit"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitUserPassApi"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div
                      v-if="isUpdate"
                      class="mt-3 w-full"
                    >
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        <span class="text-xs sm:text-sm"
                          >Choose a different ELD provider</span
                        >
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-center mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span> -->
          <!-- <div class="w-full">
              <radio-button :item="checkboxText" :active="isChecked == true" :handleSelect="handleCheckbox"
                name="checkbox-confirm"></radio-button>
            </div> -->
          <!-- <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
        <div
          v-else-if="
            latest_carrier_eld_provider?.connect_channel?.is_oauth !== true ||
            temporarilyCollectUsernameAndPassword
          "
          class="my-8"
        >
          <div
            class="flex flex-col items-center justify-between rounded-md border border-light-gray bg-white"
          >
            <div
              v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url"
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4"
            >
              <img
                class="h-full max-h-16 w-auto"
                :src="latest_carrier_eld_provider?.connect_channel?.logo?.url"
                :alt="latest_carrier_eld_provider?.connect_channel?.name"
              />
            </div>
            <div
              v-else
              class="flex h-full w-full items-center justify-center rounded-t-md border-b border-light-gray px-4 py-4 text-xl"
            >
              {{ latest_carrier_eld_provider?.connect_channel?.name }}
            </div>
            <div
              v-if="showVerificationStatus"
              class="flex w-full flex-col items-center justify-between gap-2 px-5 py-3"
            >
              <div
                class="mt-3 flex w-full flex-col rounded-md border border-light-gray"
              >
                <div
                  class="flex flex-shrink-0 items-center justify-start gap-3 bg-off-white py-3 pl-4 pr-5"
                  :class="[
                    credentialStatus !== ''
                      ? 'rounded-t-md border-b border-light-gray'
                      : 'rounded-md',
                  ]"
                >
                  <dynamic-checkmark :status="credentialStatus" />
                  <div class="text-left">
                    <div class="whitespace-nowrap leading-tight">
                      {{
                        credentialStatus == 'success'
                          ? 'Credentials Verified'
                          : credentialStatus === false
                            ? 'Invalid Credentials'
                            : 'Verifying Credentials'
                      }}
                    </div>
                    <div
                      v-if="pollingActive"
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      <span v-if="flashUpdate">Updating data...</span>
                      <span v-else>Processing...</span>
                    </div>
                    <div
                      v-else-if="
                        currentEldIntegration?.eld_credentials_verified_at &&
                        !errorDate.isSame(
                          currentEldIntegration?.eld_credentials_verified_at,
                          'year'
                        )
                      "
                      class="text-2xs leading-tight text-gray-over-dark"
                    >
                      Updated {{ credentialsVerifiedTimeElapsed }} ago
                    </div>
                  </div>
                </div>
                <div
                  v-if="credentialStatus !== ''"
                  class="flex items-center px-5 py-4"
                >
                  <span
                    v-if="credentialStatus == 'success'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials have been successfully verified.</span
                  >
                  <span
                    v-if="credentialStatus == 'fail'"
                    class="text-left text-sm text-body-color"
                    >Your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials appear to be invalid.</span
                  >
                  <span
                    v-if="credentialStatus == 'pending'"
                    class="text-left text-sm text-body-color"
                    >The validation of your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    credentials is taking longer than expected. Please check
                    back soon.</span
                  >
                </div>
              </div>
              <div class="mb-3 mt-2 w-full">
                <div
                  v-if="credentialStatus !== 'success'"
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="secondary"
                    @click="handleUpdateCredentials"
                  >
                    Update Credentials
                  </button-main>
                </div>
                <div
                  v-else
                  class="mt-3 w-full"
                >
                  <button-main
                    variant="primary"
                    @click="closeEld"
                  >
                    Continue
                  </button-main>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex w-full flex-col items-center justify-between px-5 py-3"
            >
              <div class="mt-3 w-full text-left text-body-color">
                <span class="leading-0 text-start text-lg text-dark-gray"
                  >{{ isUpdate ? 'Update' : 'Enter' }} your credentials</span
                >
                <div
                  v-if="temporarilyCollectUsernameAndPassword"
                  class="text-xs text-body-color"
                >
                  We are currently in the process of integrating with
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}. In
                  the meantime, please provide us with the credentials for your
                  {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  account so that we can securely verify your equipment and
                  recent activity.
                </div>
                <div
                  v-else
                  class="text-xs text-body-color"
                >
                  Your credentials will be used to securely verify your
                  equipment and recent activity.
                </div>
              </div>
              <div class="mt-3 flex w-full items-center justify-center">
                <div class="flex w-full flex-col gap-3">
                  <div class="relative w-full">
                    <input
                      v-model="user_email"
                      type="text"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :class="[
                        !showErrors
                          ? ''
                          : !isValidEmail
                            ? 'failed-validation border-red-500 bg-red-100 text-red-500 hover:border-red-500 focus:border-red-500 focus:bg-red-100 focus:text-red-500'
                            : '',
                      ]"
                      :placeholder="getUsernameDescription"
                    />
                    <span
                      v-if="showErrors && !isValidEmail"
                      class="block pl-1 pt-0.5 text-left text-2xs text-red-500"
                      >Username must be a valid email address</span
                    >
                  </div>
                  <div class="relative w-full">
                    <input
                      v-model="user_code"
                      :type="code_input_type"
                      class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
                      :placeholder="getPasswordDescription"
                      style="padding-right: 40px"
                    />
                    <div
                      v-if="user_code?.length > 0"
                      class="absolute right-3 top-0 flex h-full items-center justify-center"
                    >
                      <div
                        class="cursor-pointer text-gray-over-dark"
                        @click="code_visible = !code_visible"
                      >
                        <svg
                          v-if="code_visible == false"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                          <path
                            fill-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-5 w-5"
                        >
                          <path
                            d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
                          />
                          <path
                            d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
                          />
                          <path
                            d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 w-full pb-2">
                    <button-main
                      :disabled="!canSubmit"
                      :is-loading="isLoading"
                      :variant="
                        latest_carrier_eld_provider?.connect_channel
                          ?.brand_color_hex_code == '#000000'
                          ? 'primary'
                          : 'custom'
                      "
                      :custom-bg="buttonBg"
                      @click="handleSubmitVerify"
                    >
                      {{ isUpdate ? 'Update' : 'Continue' }}
                    </button-main>
                    <div class="mt-3 w-full">
                      <button-main
                        variant="secondary"
                        @click="handleBack"
                      >
                        Choose a different ELD provider
                      </button-main>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <p class="h4-style mb-6 -mt-3">Authenticate through {{ latest_carrier_eld_provider?.connect_channel?.name }}
          </p>

          <p class="mt-6 mb-1 dark-blue text-base">Step 1</p>
          <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <div class="w-full mb-2">
              <span class="text-start text-dark-gray text-sm mt-3">Enter your {{ latest_carrier_eld_provider?.connect_channel?.name }} credentials</span>
              <div v-if="latest_carrier_eld_provider?.connect_channel?.logo?.url" class="flex justify-center items-center w-full h-full px-4 mt-4">
                  <img class="w-auto h-full max-h-16" :src="latest_carrier_eld_provider?.connect_channel?.logo?.url" :alt="latest_carrier_eld_provider?.connect_channel?.name">
              </div>
            </div>
            <div class="flex justify-start items-center w-full mt-4">
              <div class="flex flex-col gap-3 w-full">
                <div class="w-full relative">
                  <input type="text" v-model="user_email"
                    class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray" placeholder="Username"/>
                </div>
                <div class="w-full relative">
                  <input :type="code_input_type" v-model="user_code"
                    class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray" placeholder="Password"
                    style="padding-right: 40px;" />
                  <div v-if="user_code?.length > 0" class="absolute right-3 top-0 h-full flex items-center justify-center">
                    <div @click="code_visible = !code_visible" class="text-gray-over-dark cursor-pointer">
                      <svg v-if="code_visible == false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                        <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                        <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clip-rule="evenodd" />
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                        <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                        <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                        <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <p class="mt-6 mb-1 dark-blue text-base">Step 2</p>
          <div class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5">
            <span class="w-full text-sm text-start mt-3 mb-2 text-dark-gray">Submit and hang tight while we verify your account</span>
            
            <div class="mt-4 w-full">
              <button-main @click="handleSubmit" :disabled="!canSubmit" :isLoading="isLoading" variant="primary">Submit
              </button-main>
            </div>
            <div class="mt-3 w-full">
              <button-main @click="handleBack" variant="secondary">Back</button-main>
            </div>
          </div> -->
          <p
            v-if="broker?.support_email"
            class="ml-1 mt-2 text-xxs text-body-color md:mt-4"
          >
            <span>For more information, contact this Broker directly at </span>
            <!-- TODO set dynamic link  -->
            <a
              class="text-link underline"
              href="mailto:{{broker?.support_email}}"
              >{{ broker?.support_email }}</a
            >
            <span>.</span>
          </p>
        </div>
      </div>
      <div
        v-else-if="
          latest_carrier_eld_provider?.connect_channel?.eld_type &&
          latest_carrier_eld_provider?.connect_channel?.eld_type == 'eld_exempt'
        "
        class="w-full"
      >
        <h1 class="header-text mt-8">Equipment Verification</h1>
        <p class="mb-3 mt-4 text-body-color">
          The broad ELD mandate of 2015 outlines certain conditions in which a
          carrier is exempt from HOS and RODS requirements. If you qualify for
          these specific exemptions, please verify your equipment by uploading
          the documents below.
        </p>
        <div class="mt-8 flex flex-col gap-y-8">
          <div>
            <p class="text-left text-sm text-dark-gray">
              Title or Loan Agreement (Required)
            </p>
            <div class="mt-4">
              <file-selector-grid
                v-model="title_upload_files"
                :multiple="true"
                accept="image/*,.pdf"
              />
            </div>
          </div>
          <div>
            <p class="text-left text-sm text-dark-gray">
              Cab Card or Registration (Required)
            </p>
            <div class="mt-4">
              <file-selector-grid
                v-model="cab_card_upload_files"
                :multiple="true"
                accept="image/*,.pdf"
              />
            </div>
          </div>
          <div>
            <p class="text-left text-sm text-dark-gray">
              Driver's License (Required)
            </p>
            <div class="mt-4">
              <file-selector-grid
                v-model="drivers_license_upload_files"
                :multiple="true"
                accept="image/*,.pdf"
              />
            </div>
          </div>
          <div>
            <p class="text-left text-sm text-body-color">
              Your submission will be placed in a "Pending" status and you will
              be included in an email immediately sent to
              {{ broker?.legal_name }} requesting a review of the documents you
              provide.
            </p>
          </div>
        </div>
        <div class="mt-6 w-full">
          <button-main
            :disabled="
              !(
                title_upload_files?.length !== 0 &&
                cab_card_upload_files?.length !== 0 &&
                drivers_license_upload_files?.length !== 0
              )
            "
            :is-loading="isLoading"
            variant="primary"
            @click="handleSubmitExempt"
          >
            Submit
          </button-main>
        </div>
        <div class="mt-3 w-full">
          <button-main
            variant="secondary"
            @click="handleBack"
          >
            Back
          </button-main>
        </div>
        <p
          v-if="broker?.support_email"
          class="mb-16 ml-1 mt-2 text-xxs text-body-color md:mt-4"
        >
          <span>For more information, contact this Broker directly at </span>
          <!-- TODO set dynamic link  -->
          <a
            class="text-link underline"
            href="mailto:{{broker?.support_email}}"
            >{{ broker?.support_email }}</a
          >
          <span>.</span>
        </p>
      </div>
      <div
        v-else
        class="w-full"
      >
        <!-- <h1 class="header-text">Equipment Verification</h1> -->
        <span
          class="loading-gradient relative -top-1 mt-8 block w-full rounded-md bg-light-gray py-2 text-transparent"
          >Loading...</span
        >
        <div class="mt-8 flex flex-col gap-2">
          <span
            v-for="index in 7"
            :key="`eld-loading-${index}`"
            class="loading-gradient relative -top-1 block w-full rounded-md bg-light-gray py-1 text-transparent"
            >Loading...</span
          >
        </div>
      </div>
    </holding-tank-layout-wide>
  </div>
</template>

<script>
import { toastResponse } from '@/common/handleServerResponse';
import ButtonMain from '@/components/Button.vue';
// import FormField from "@/components/FormField.vue";
import HoldingTankLayoutWide from '@/components/layouts/HoldingTankLayoutWide.vue';
// import RoundRadioButtonVertical from "@/components/RoundRadioButtonVertical.vue";
import IntegrationCta from '@/components/IntegrationCta.vue';
// import EldCta from "@/components/EldCta.vue";
// import EldCtaApi from "@/components/EldCtaApi.vue";
// import IntegrationLoginModalEquipment from "@/components/modals/IntegrationLoginModalEquipment.vue";
import stepInformation from '@/common/stepInformation';
import RadioButton from '@/components/RadioButton.vue';
import FileSelectorGrid from '@/components/FileSelectorGrid.vue';
import DynamicCheckmark from '@/components/DynamicCheckmark.vue';
import SiteNotice from '@/components/SiteNotice.vue';
import { isEmail, formatPhoneParenthesis } from '@/common/validators';
import { dayjsExtended, getTimeElapsed } from '@/common/timestamps.js';
import { VueCollapsiblePanel } from '@dafcoe/vue-collapsible-panel';

export default {
  name: 'ConnectEld',
  components: {
    HoldingTankLayoutWide,
    // RoundRadioButtonVertical,
    IntegrationCta,
    // IntegrationLoginModalEquipment,
    ButtonMain,
    RadioButton,
    // EldCta,
    // EldCtaApi,
    FileSelectorGrid,
    DynamicCheckmark,
    VueCollapsiblePanel,
    SiteNotice,
  },
  data() {
    return {
      items: [],
      selectedItem: '',
      showModalMotive: false,
      showModalSamsara: false,
      modalToShow: null,
      isChecked: false,
      isMarketplaceChecked: false,
      canSubmit: false,
      isLoading: false,
      eld_verifier: '',
      eld_verifier_id: '',
      eld_verifier_company_id: '',
      verifier_visible: false,
      copy_button_text: 'Copy',
      title_upload_files: [],
      cab_card_upload_files: [],
      drivers_license_upload_files: [],
      user_email: null,
      user_code: null,
      code_visible: false,
      showErrors: false,
      showVerificationStatus: false,
      temporarilyCollectUsernameAndPassword: false,
      verificationCheckCount: 0,
      credentialStatus: '',
      flashUpdate: false,
      pollingActive: false,
      pollStart: null,
      certification_email_message: '',
      integration_options: [
        {
          name: 'Motive',
          value: 'motive',
          bg_brand_color_class: 'brand-motive',
        },
        {
          name: 'Samsara',
          value: 'samsara',
          bg_brand_color_class: 'brand-samsara',
        },
        {
          name: 'Fleethunt Technologies',
          value: 'fleethunt_technologies',
          bg_brand_color_class: 'brand-fleethunt-technologies',
        },
        {
          name: 'Omnitracs VLV',
          value: 'omnitracs_vlv',
          bg_brand_color_class: 'brand-omnitracs-vlv',
        },
        {
          name: 'BigRoad',
          value: 'bigroad',
          bg_brand_color_class: 'brand-bigroad',
        },
        {
          name: 'Geotab',
          value: 'geotab',
          bg_brand_color_class: 'brand-geotab',
        },
        {
          name: 'PeopleNet',
          value: 'peoplenet',
          bg_brand_color_class: 'brand-peoplenet',
        },
        {
          name: 'Verizon Reveal',
          value: 'verizon_reveal',
          bg_brand_color_class: 'brand-verizon-reveal',
        },
        {
          name: 'EROAD',
          value: 'eroad',
          bg_brand_color_class: 'brand-eroad',
        },
        {
          name: 'GPS Insight',
          value: 'gps_insight',
          bg_brand_color_class: 'brand-gps-insight',
        },
        {
          name: 'VisTracks',
          value: 'vistracks',
          bg_brand_color_class: 'brand-vistracks',
        },
        {
          name: 'Omnitracs',
          value: 'omnitracs',
          bg_brand_color_class: 'brand-omnitracs',
        },
        {
          name: 'Rand McNally',
          value: 'rand_mcnally',
          bg_brand_color_class: 'brand-rand-mcnally',
        },
      ],
    };
  },
  computed: {
    getWidth() {
      return (this.highway_username?.length + 3) * 8 + 'px';
    },
    broker() {
      return this.$store.state.company.company;
    },
    isUpdate() {
      return this.$store.state.integrations?.updateEld;
    },
    apiInstructionsUrl() {
      return this.latest_carrier_eld_provider?.connect_channel
        ?.api_instructions_url;
    },
    manualLoginUrl() {
      return this.latest_carrier_eld_provider?.connect_channel
        ?.manual_login_url;
    },
    message() {
      return `Sign in to your ${this.latest_carrier_eld_provider?.connect_channel?.name} account`;
    },
    packetId() {
      return this.$store.state.onboardingPacket?.id;
    },
    eld_verifier_input_type() {
      if (this.verifier_visible) {
        return 'text';
      } else {
        return 'password';
      }
    },
    code_input_type() {
      if (this.code_visible) {
        return 'text';
      } else {
        return 'password';
      }
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    carrier_id() {
      return this.$store.state.carriers.carrierData?.identity?.id;
    },
    verificationSuccessful() {
      return this.currentEldIntegration?.eld_credentials_verified;
    },
    currentEldIntegration() {
      return this.$store.state.onboardingPacket?.current_eld_integration;
    },
    currentEldIntegrationHasLoaded() {
      return (
        this.$store.state.onboardingPacket
          ?.current_eld_integration_has_loaded || false
      );
    },
    hasEldConnectedAndActive() {
      return this.currentEldIntegration?.has_eld_connected_and_active;
    },
    currentIntegration() {
      if (!this.latest_carrier_eld_provider?.connect_channel?.eld_type) {
        return null;
      }
      let options = this.integration_options;
      if (options?.length == 0) {
        return null;
      } else {
        return options.find(
          (option) =>
            option?.value ===
            this.latest_carrier_eld_provider?.connect_channel?.eld_type
        );
      }
    },
    checkboxText() {
      return `I have added ${this.highway_username} to my ${this.latest_carrier_eld_provider?.connect_channel?.name} account`;
    },
    brokerLogo() {
      return this.$store.state.company?.company?.logo?.url;
    },
    highway_username() {
      return `eld${this.latest_carrier_eld_provider?.carrier_id}@highway.com`;
    },
    buttonBg() {
      return this.latest_carrier_eld_provider?.connect_channel
        ?.brand_color_hex_code == '#000000'
        ? ''
        : this.latest_carrier_eld_provider?.connect_channel
            ?.brand_color_hex_code;
    },
    isValidEmail() {
      return isEmail(this.user_email);
    },
    eldIntegrationId() {
      return this.$store.state.onboardingPacket.eld_integration_id;
    },
    errorDate() {
      return dayjsExtended('1969-12-31 18:00:00.000000');
    },
    credentialsVerifiedTimeElapsed() {
      if (!this.currentEldIntegration?.eld_credentials_verified_at) return null;
      return getTimeElapsed(
        this.currentEldIntegration?.eld_credentials_verified_at
      );
    },
    currentEldIntegrationCredentialsVerifiedAt() {
      return this.currentEldIntegration?.eld_credentials_verified_at;
    },
    hasIntegrationCompletedCredentialValidation() {
      if (!this.pollStart || !this.currentEldIntegrationCredentialsVerifiedAt)
        return false;
      const pollStartDate = dayjsExtended(this.pollStart);
      const verifiedAtDate = dayjsExtended(
        this.currentEldIntegrationCredentialsVerifiedAt
      );

      if (
        verifiedAtDate.isAfter(pollStartDate, 'second') ||
        verifiedAtDate.isSame(pollStartDate, 'second')
      ) {
        return true;
      }
      return false;
    },
    certified_eld_providers() {
      return this.$store.state.onboardingPacket?.certified_eld_providers;
    },
    certification_typeform_link() {
      return import.meta.env.VITE_CERTIFICATION_TYPEFORM_LINK || '';
    },
    certification_site_notice_expiration() {
      return import.meta.env.VITE_CERTIFICATION_SITE_NOTICE_EXPIRATION || '';
    },
    should_show_certification_site_notice_expiration() {
      if (!this.certification_site_notice_expiration) return false;
      if (
        dayjsExtended().isBefore(
          this.certification_site_notice_expiration,
          'day'
        )
      ) {
        return true;
      }
      return false;
    },
    siteNoticeText() {
      if (!this.should_show_certification_site_notice_expiration) return false;
      let date = dayjsExtended(
        this.certification_site_notice_expiration
      ).format('dddd, MMMM Do');
      let days = dayjsExtended(this.certification_site_notice_expiration).diff(
        dayjsExtended(),
        'day'
      );
      let daysText = days > 1 ? days + ' days from today' : 'tomorrow';
      return `Effective ${daysText}, on ${date}, ${this.latest_carrier_eld_provider?.connect_channel?.name} will no longer be supported by Highway. Please use the information below to contact your current provider and recommend that it get certified by Highway.`;
    },
    isEnabled_show_eld_coi_updates_in_onboarding() {
      return (
        this.$store.state.carriers?.carrierDetails
          ?.is_eld_vin_required_to_match_coi_vin ||
        this.$store.state.users.currentUser?.requested_carrier
          ?.is_eld_vin_required_to_match_coi_vin
      );
      // return this.$store.getters['users/getFeatureFlag']?.(
      //   'show_eld_coi_updates_in_onboarding'
      // )?.['enabled'];
    },
    failingEldStatuses() {
      return this.$store.state.onboardingPacket?.failing_eld_statuses;
    },
    hasFailingEldStatus() {
      if (this.eldStatus?.length > 0) {
        return this.failingEldStatuses.includes(this.eldStatus);
      } else {
        return false;
      }
    },
    eldStatus() {
      return this.$store.state.onboardingPacket?.eld_status;
    },
    getCgRootDescription() {
      const connectChannel = this.latest_carrier_eld_provider?.connect_channel;

      if (connectChannel?.client_token_description) {
        return connectChannel.client_token_description;
      }

      return connectChannel?.retrieval_type === 'username_pass_and_c_g_root'
        ? 'CGRootId'
        : 'Company ID';
    },
    getUsernameDescription() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.client_username_description ?? 'Username'
      );
    },
    getPasswordDescription() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.client_password_description ?? 'Password'
      );
    },
    getApiIdDescription() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.client_api_id_description ?? 'API ID'
      );
    },
    getCompanyIdDescription() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.client_company_id_description ?? 'API Company Identifier'
      );
    },
    getApiKeyDescription() {
      const connectChannel = this.latest_carrier_eld_provider?.connect_channel;
      const retrievalType = connectChannel?.retrieval_type;
      const clientTokenDescription = connectChannel?.client_token_description;

      if (
        retrievalType === 'api_id_and_api_key' &&
        clientTokenDescription?.length > 0
      ) {
        return clientTokenDescription;
      }

      return connectChannel?.client_api_id_description ?? 'Paste API Key here';
    },
  },
  watch: {
    hasIntegrationCompletedCredentialValidation: {
      handler: async function (val) {
        let self = this;
        if (!val) return;
        if (self.verificationSuccessful === null) return;
        if (self.verificationSuccessful == true) {
          setTimeout(() => {
            self.obtainEldStatus();
          }, 1000);
          // self.credentialStatus = 'success';
          // self.pollingActive = false;
        } else if (self.verificationSuccessful == false) {
          self.credentialStatus = 'fail';
          self.pollingActive = false;
        }
        self.updateLatestEldProviderAndIntegration();
      },
    },
    latest_carrier_eld_provider: function (val) {
      if (val && val?.has_setup_manual_connection == true) {
        this.isChecked = true;
      } else if (val == null) {
        this.$store.dispatch(
          'onboardingPacket/getLatestEldProvider',
          this.$store.state.carriers?.carrierData?.connection?.carrier_id
        );
      }
    },
    user_email: function (val) {
      if (val && this.user_code) {
        if (
          ![
            'username_pass_and_api_key_for_api',
            'username_pass_and_c_g_root',
          ].includes(
            this.latest_carrier_eld_provider?.connect_channel?.retrieval_type
          )
        ) {
          this.canSubmit = true;
        } else if (
          this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
          'username_pass_and_api_key_for_api'
        ) {
          if (this.eld_verifier) {
            this.canSubmit = true;
          } else {
            this.canSubmit = false;
          }
        } else if (
          this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
          'username_pass_and_c_g_root'
        ) {
          if (this.eld_verifier_company_id) {
            this.canSubmit = true;
          } else {
            this.canSubmit = false;
          }
        }
      } else {
        this.canSubmit = false;
      }
    },
    user_code: function (val) {
      if (val && this.user_email) {
        if (
          ![
            'username_pass_and_api_key_for_api',
            'username_pass_and_c_g_root',
          ].includes(
            this.latest_carrier_eld_provider?.connect_channel?.retrieval_type
          )
        ) {
          this.canSubmit = true;
        } else if (
          this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
          'username_pass_and_api_key_for_api'
        ) {
          if (this.eld_verifier) {
            this.canSubmit = true;
          } else {
            this.canSubmit = false;
          }
        } else if (
          this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
          'username_pass_and_c_g_root'
        ) {
          if (this.eld_verifier_company_id) {
            this.canSubmit = true;
          } else {
            this.canSubmit = false;
          }
        }
      } else {
        this.canSubmit = false;
      }
    },
    eld_verifier: function (val) {
      if (
        this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
        'username_pass_and_api_key_for_api'
      ) {
        if (val && this.user_email && this.user_code) {
          this.canSubmit = true;
        } else {
          this.canSubmit = false;
        }
      }
    },
    eld_verifier_company_id: function (val) {
      if (
        this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
        'username_pass_and_c_g_root'
      ) {
        if (val && this.user_email && this.user_code) {
          this.canSubmit = true;
        } else {
          this.canSubmit = false;
        }
      }
    },
    carrier_id: function (val) {
      if (val > 0) {
        if (this.latest_carrier_eld_provider === null) {
          this.$store.dispatch('onboardingPacket/getLatestEldProvider', val);
        }
      }
    },
    eldStatus: function (val) {
      if (val?.length > 0) {
        if (!this.failingEldStatuses.includes(val)) {
          this.credentialStatus = 'success';
        } else {
          this.credentialStatus = 'fail';
        }
        this.pollingActive = false;
      }
    },
    showVerificationStatus: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$store.commit('onboardingPacket/setEldStatus', '');
      }
    },
  },
  mounted() {
    this.items = stepInformation.verify_physical_assets;
    if (!this.packetId) {
      this.getOnboardingPacket();
    }
    this.$store.dispatch('onboardingPacket/getConnectSubscriptions');
    this.$store.dispatch(
      'users/refreshCurrentFeatureFlags',
      this.$store.state.users.currentUser?.id
    );
    // if (this.latest_carrier_eld_provider?.has_setup_manual_connection == true) {
    //   this.isChecked = true;
    // }
    if (
      this.latest_carrier_eld_provider?.integration?.username &&
      this.latest_carrier_eld_provider?.integration?.password
    ) {
      this.user_email = this.latest_carrier_eld_provider?.integration?.username;
      this.user_code = this.latest_carrier_eld_provider?.integration?.password;
      this.can_submit = true;
    }
    if (this.certified_eld_providers?.length < 1) {
      this.$store.dispatch('onboardingPacket/getEldProviders');
    }
    this.initCertificationEmail();
    if (
      this.latest_carrier_eld_provider &&
      this.latest_carrier_eld_provider?.connect_channel?.retrieval_type ==
        'marketplace_request' &&
      !this.latest_carrier_eld_provider.integration?.id
    ) {
      this.handleAutoSubmitMarketplaceRequest();
    }
  },
  methods: {
    async redirectTo(url) {
      window.open(url, '_blank');

      await this.$store.dispatch('onboardingPacket/updateCarrierEldProvider', {
        id: this.latest_carrier_eld_provider?.id,
        body: {
          carrier_eld_provider: {
            has_setup_manual_connection: true,
          },
        },
      });
    },
    initCertificationEmail() {
      this.certification_email_message = `This is ${this.$store.state.users.currentUser?.first_name} ${this.$store.state.users.currentUser?.last_name} and I'm contacting you on behalf of my company, ${this.$store.state.users.currentUser?.company?.legal_name}. We are a customer of ${this.latest_carrier_eld_provider?.connect_channel?.name} and I am unable to connect my ELD to Highway because you are not certified by Highway.\n\nPlease click this link to start the certification process: ${this.certification_typeform_link}\n\nThank you,\n${this.$store.state.users.currentUser?.first_name} ${this.$store.state.users.currentUser?.last_name}`;
    },
    async handleSendCertificationEmail() {
      await this.$store.dispatch(
        'onboardingPacket/updateCarrierEldProviderForCertificationInvite',
        this.latest_carrier_eld_provider?.id
      );
      let message = this.certification_email_message?.replace(/\n/g, '%0D%0A');
      window.open(
        `mailto:${this.latest_carrier_eld_provider?.connect_channel?.marketing_email}?subject=Highway%20Certification%20Request&body=${message}`
      );
      if (
        !this.should_show_certification_site_notice_expiration &&
        !this.latest_carrier_eld_provider?.connect_channel
          ?.is_manual_eld_signup_allowed
      ) {
        this.closeEld();
      }
    },
    getAuthenticationMessage(is_oauth) {
      if (is_oauth == true) {
        // return 'Share your equipment data and last 7 days of location data with Highway.';
        return '';
      }
      return 'Your connection will be used to securely verify your equipment and current location. Highway does not access driver or hours of service (HOS) information.';
    },
    handleSelectRadio(e, value) {
      if (e?.target?.name) {
        this.selectedItem = value;
      }
    },
    phoneFormat(phone) {
      return formatPhoneParenthesis(phone);
    },
    async handleBack() {
      await this.$store.commit('integrations/setUpdateEld', false);
      this.$router.push({
        name: 'Carrier Verify Equipment',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    handleUpdateCredentials() {
      this.isLoading = false;
      this.showVerificationStatus = false;
      this.credentialStatus = '';
    },
    async handleSubmitVerify() {
      if (
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_email_required_for_login
      ) {
        if (this.isValidEmail) {
          this.handleSubmit();
        } else {
          this.showErrors = true;
        }
      } else {
        this.handleSubmit();
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      let res = await this.$store.dispatch(
        'onboardingPacket/updateCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body: {
            user_email: this.user_email,
            user_code: this.user_code,
            carrier_eld_provider: {
              has_setup_manual_connection: true,
            },
          },
        }
      );
      this.handlePostSubmit(res);
    },
    async closeEld() {
      this.$router.push({
        name: 'Carrier Onboarding Packet Status',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async handleSubmitApi() {
      this.isLoading = true;
      let body = {
        carrier_eld_provider: {
          has_completed_connect_channel: true,
        },
      };
      if (this.eld_verifier?.length > 0) {
        body['access_token'] = this.eld_verifier;
      }
      if (this.eld_verifier_id?.length > 0) {
        body['api_key_id'] = this.eld_verifier_id;
      }
      if (this.eld_verifier_company_id?.length > 0) {
        body['api_company_identifier'] = this.eld_verifier_company_id;
      }
      let res = await this.$store.dispatch(
        'onboardingPacket/updateApiCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body,
        }
      );
      this.handlePostSubmit(res);
    },
    async handleSubmitMarketplace() {
      this.isLoading = true;
      let body = {
        carrier_eld_provider: {
          has_completed_connect_channel: true,
        },
      };
      let res = await this.$store.dispatch(
        'onboardingPacket/updateApiCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body,
        }
      );
      this.handlePostSubmit(res);
    },
    async handleAutoSubmitMarketplaceRequest() {
      let body = {
        carrier_eld_provider: {
          has_setup_manual_connection: true,
        },
      };
      let res = await this.$store.dispatch(
        'onboardingPacket/updateApiCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body,
        }
      );
      if ([200, 201, 204].includes(res?.status)) {
        this.$store.commit(
          'onboardingPacket/setLatestCarrierEldProvider',
          res?.data
        );
      }
    },
    async handleSubmitUserPassCGRoot() {
      this.isLoading = true;
      let body = {
        username: this.user_email,
        password: this.user_code,
        carrier_eld_provider: {
          has_completed_connect_channel: true,
        },
      };
      if (this.eld_verifier_company_id?.length > 0) {
        body['api_company_identifier'] = this.eld_verifier_company_id;
      }
      let res = await this.$store.dispatch(
        'onboardingPacket/updateApiCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body,
        }
      );
      this.handlePostSubmit(res);
    },
    async handleSubmitUserPassApi() {
      this.isLoading = true;
      let body = {
        username: this.user_email,
        password: this.user_code,
        carrier_eld_provider: {
          has_completed_connect_channel: true,
        },
      };
      if (this.eld_verifier?.length > 0) {
        body['access_token'] = this.eld_verifier;
      }
      let res = await this.$store.dispatch(
        'onboardingPacket/updateApiCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body,
        }
      );
      this.handlePostSubmit(res);
    },
    async handleSubmitExempt() {
      this.isLoading = true;
      let res = await this.$store.dispatch(
        'onboardingPacket/uploadCarrierEldProviderDocuments',
        {
          id: this.latest_carrier_eld_provider?.id,
          title_uploads: this.title_upload_files,
          cab_card_uploads: this.cab_card_upload_files,
          drivers_license_uploads: this.drivers_license_upload_files,
        }
      );
      if (res) {
        toastResponse(this, res, 'Files successfully uploaded');
      }
      this.$router.push({
        name: 'Carrier Onboarding Packet Status',
        params: {
          id: this.$route.params.id,
        },
      });
      this.isLoading = false;
    },
    async handlePostSubmit(res) {
      if (
        res?.data?.id > 0 &&
        (res?.data?.connect_channel?.is_manual_eld_signup_allowed ||
          this.should_show_certification_site_notice_expiration) &&
        res?.data?.connect_channel?.is_certified_eld == false &&
        ![
          'manual',
          'browser_automation',
          'username_and_password',
          'username_pass_and_company_id',
          'username_pass_and_api_key_for_api',
          'username_pass_and_c_g_root',
        ].includes(res?.data?.connect_channel?.retrieval_type) &&
        !(res?.data?.connect_channel?.retrieval_type == null) &&
        res?.data?.integration?.id > 0 &&
        (!res?.data?.integration?.has_username ||
          !res?.data?.integration?.has_password)
      ) {
        this.temporarilyCollectUsernameAndPassword = true;
        this.isLoading = false;
      } else if (
        res?.data?.id > 0 &&
        res?.data?.connect_channel?.is_auto_eld_credentials
      ) {
        this.temporarilyCollectUsernameAndPassword = false;
        this.showVerificationStatus = true;
        this.$store.commit(
          'onboardingPacket/setLatestCarrierEldProvider',
          res?.data
        );
        if (res?.data?.integration?.id > 0) {
          await this.$store.dispatch(
            'onboardingPacket/updateEldIntegrationId',
            res?.data?.integration?.id
          );
          this.startPollVerification();
        } else {
          this.$rollbar.error(
            'ELD connection error - integration not created',
            {
              customData: {
                carrier_eld_provider_id: res?.data?.id,
                res: res,
                data: res?.data,
                status: res?.status,
              },
            }
          );
        }
      } else {
        this.temporarilyCollectUsernameAndPassword = false;
        if (res) {
          toastResponse(
            this,
            res,
            'You will be immediately notified when your pending ELD connection is completed.'
          );
          // if (res?.data?.id > 0) {
          //   this.$store.dispatch("onboardingPacket/getEldProviderById", res?.data?.id);
          // }
        }
        this.$router.push({
          name: 'Carrier Onboarding Packet Status',
          params: {
            id: this.$route.params.id,
          },
        });
        this.isLoading = false;
        this.showVerificationStatus = false;
      }
    },
    handleModalToShow(modalName) {
      this.modalToShow = modalName;
    },
    updateIntegrations(path, value) {
      let newArray =
        this.data.integrations.systems.indexOf(value) === -1
          ? [...this.data.integrations.systems, value]
          : this.data.integrations.systems;
      this.updateNestedField(path, newArray);
    },
    onCloseModal() {
      this.modalToShow = null;
    },
    async getOnboardingPacket() {
      await this.$store.dispatch('onboardingPacket/getOnboardingPacketById', {
        id: this.$route.params.id,
      });
      await this.$store.dispatch('carriers/getRulesSyntax');
      await this.$store.dispatch(
        'company/getCompanyByClientId',
        localStorage.getItem('client_id')
      );
    },
    handleCheckbox() {
      this.isChecked = !this.isChecked;
    },
    handleMarketplaceCheckbox() {
      this.isMarketplaceChecked = !this.isMarketplaceChecked;
    },
    copyHighwayUsername() {
      this.$refs.clone.focus();
      document.execCommand('copy');
      var activeEl = document.activeElement;
      if (activeEl) {
        var tagName = activeEl.nodeName.toLowerCase();
        if (
          tagName == 'textarea' ||
          (tagName == 'input' && activeEl.type == 'text')
        ) {
          // Collapse the selection to the end
          activeEl.selectionStart = activeEl.selectionEnd;
        }
      }
      this.$refs.clone.blur();
      this.copy_button_text = 'Copied!';
      setTimeout(() => {
        this.copy_button_text = 'Copy';
      }, 2000);
    },
    startPollVerification() {
      console.log('gets here 4');
      this.pollStart = new Date().toISOString();
      this.pollVerification();
    },
    async pollVerification() {
      console.log('gets here - poll ');
      this.pollingActive = true;
      let self = this;
      this.verificationCheckCount += 1;
      if (this.hasIntegrationCompletedCredentialValidation == false) {
        if (this.verificationCheckCount < 5) {
          await this.updateVerification();
          setTimeout(() => {
            self.pollVerification();
          }, 5000);
        } else if (this.verificationCheckCount < 15) {
          await this.updateVerification();
          setTimeout(() => {
            self.pollVerification();
          }, 10000);
        } else {
          // taking too long, end polling and show message
          this.credentialStatus = 'pending';
          this.pollingActive = false;
        }
      } else {
        this.pollingActive = false;
      }
    },
    async updateVerification() {
      console.log(
        'Running updateVerification check #' + this.verificationCheckCount
      );
      this.flashUpdate = true;
      await this.$store.dispatch(
        'onboardingPacket/getEldIntegrationById',
        this.eldIntegrationId
      );
    },
    async updateLatestEldProviderAndIntegration() {
      let res = await this.$store.dispatch(
        'onboardingPacket/getLatestEldProvider',
        this.$store.state.users?.currentUser?.company?.carrier_id
      );
      if (res?.data?.[0]?.integration?.id > 0) {
        await this.$store.dispatch(
          'onboardingPacket/getEldIntegrationById',
          res?.data?.[0]?.integration?.id
        );
      }
    },
    openApiInstructionsUrl() {
      window.open(this.apiInstructionsUrl, '_blank');
    },
    openManualLoginUrl() {
      window.open(this.manualLoginUrl, '_blank');
    },
    marketplaceCheckboxText(name) {
      return `I have added Highway to my account via the ${name} portal`;
    },
    marketplaceRequestCheckboxText(name) {
      return `I have approved Highway's request in my ${name} portal`;
    },
    async obtainEldStatus() {
      // if (this.currentEldIntegration?.connected_eld_vin_status?.length > 0) {
      //   this.$store.commit(
      //     'onboardingPacket/setEldStatus',
      //     this.currentEldIntegration?.connected_eld_vin_status
      //   );
      // } else {
      if (this.isEnabled_show_eld_coi_updates_in_onboarding) {
        const res = await this.$store.dispatch('onboardingPacket/getEldStatus');
        if ([200, 201, 304].includes(res?.status) && res?.data?.eld_status) {
          this.$store.commit(
            'onboardingPacket/setEldStatus',
            res?.data?.eld_status
          );
          return;
        }
      }
      this.credentialStatus = 'success';
      this.pollingActive = false;
      // }
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
}

.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.fail-status {
  padding: 4px 8px;
  background: #fff0e3;
  border-radius: 30px;
  font-size: 10px;
  width: 34px;
  height: 24px;
}

.h4-style {
  font-size: 18px;
  line-height: 27px;
}

.no-border {
  border: none !important;
}
</style>
